interface TierBadgeProps {
  tier: "free" | "supporter" | "pro" | string;
}

const TIER_STYLES: Record<string, string> = {
  pro: "bg-barrel/10 text-barrel border border-barrel/20",
  supporter: "bg-cellar/10 text-cellar border border-cellar/20",
  free: "bg-parchment text-terroir border border-terroir/20",
  enterprise: "bg-garnet/10 text-garnet border border-garnet/20",
};

export function TierBadge({ tier }: TierBadgeProps) {
  const style = TIER_STYLES[tier] ?? TIER_STYLES.free;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${style}`}
    >
      {tier.toUpperCase()}
    </span>
  );
}
